/* eslint-disable no-restricted-properties */
/* eslint-disable no-plusplus */
/* eslint-disable func-names */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
import * as Sentry from "@sentry/browser";

import baseCode from "./utils/baseCode";
import getCart from "./utils/getCart";
import getPixels from "./utils/getPixels";
import getProducts from "./utils/getProducts";
import {
  allMainPixelIds,
  emitPixel,
  getPixelIds,
  getTitlePrice,
  initPixels,
} from "./utils/method";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn:
      "https://a656f68d5f41463687c6224dae765814@o143559.ingest.sentry.io/5167006",
    integrations: [
      new Sentry.Integrations.GlobalHandlers({
        onerror: false,
        onunhandledrejection: false,
      }),
    ],
  });
}

(function() {
  const ie = !!(window.attachEvent && !window.opera);
  const wk = /webkit\/(\d+)/i.test(navigator.userAgent) && RegExp.$1 < 525;

  const fn = [];
  const run = function() {
    for (let i = 0; i < fn.length; i++) fn[i]();
  };
  const d = document;
  d.ready = function(f) {
    if (!ie && !wk && d.addEventListener) {
      return d.addEventListener("DOMContentLoaded", f, false);
    }
    if (fn.push(f) > 1) return;

    if (ie) {
      (function() {
        try {
          d.documentElement.doScroll("left");
          run();
        } catch (err) {
          // eslint-disable-next-line no-caller
          setTimeout(arguments.callee, 0);
        }
      })();
    } else if (wk) {
      const t = setInterval(function() {
        if (/^(loaded|complete)$/.test(d.readyState)) {
          clearInterval(t);
          run();
        }
      }, 0);
    }
  };
})();

async function mfpGeneralScript() {
  baseCode();

  let allFbPixelSets = null;

  if (window.MFP && window.MFP.FbPixelSets) {
    allFbPixelSets = window.MFP.FbPixelSets;

    // Get All-Mail pixelIds and init them right now!
    initPixels(allMainPixelIds(allFbPixelSets));

    const { collections } = window.MFP;
    const { pathname } = window.location;

    const pixelIds = getPixelIds(collections, allFbPixelSets);

    if (pathname.match(/\/products\/.+/)) {
      const getProductsData = await getProducts();
      const titlePrice = getTitlePrice(getProductsData);

      let selectedProductTitle = "";
      let data = {};
      const linstenSelectedProduct = setInterval(() => {
        const getSelectedProduct = document.querySelector(
          "form[action='/cart/add'] select[name='id'] option[selected]"
        );
        if (getSelectedProduct) {
          clearInterval(linstenSelectedProduct);
          const selectedProductId = getSelectedProduct.value;
          getProductsData.product.variants.map((product) => {
            if (product.id == selectedProductId) {
              selectedProductTitle = product.title;
              return true;
            }
          });
          data = {
            content_ids: [getProductsData.product.id],
            content_type: "product_group",
            content_category: getProductsData.product.product_type,
            content_name: titlePrice
              ? titlePrice.title
              : `${getProductsData.product.title} - ${selectedProductTitle}`,
            value: titlePrice
              ? titlePrice.price
              : getProductsData.product.variants[0].price,

            currency: Shopify.currency.active,
          };

          initPixels(pixelIds);
          emitPixel("ViewContent", data);
        } else {
          console.log("not found selected product");
        }
      }, 300);

      // Add to Card
      document
        .querySelector("button[name=add]")
        .addEventListener("click", () => {
          const addTitlePrice = getTitlePrice(getProductsData);
          if (addTitlePrice) {
            data.value = addTitlePrice.price;
            data.content_name = addTitlePrice.title;
          }
          initPixels(pixelIds);
          emitPixel("AddToCart", data);
        });

      // product page buy it now
      const listenCheckoutBtn = setInterval(() => {
        if (document.querySelector("button[data-testid=Checkout-button]")) {
          console.log("got CheckoutBtn");
          clearTimeout(listenCheckoutBtn);
          document
            .querySelector("button[data-testid=Checkout-button]")
            .addEventListener("click", () => {
              try {
                console.log("checkout");
                const checkoutTitlePrice = getTitlePrice(getProductsData);
                if (checkoutTitlePrice) {
                  data.value = checkoutTitlePrice.price;
                  data.content_name = checkoutTitlePrice.title;
                }
                initPixels(pixelIds);
                emitPixel("InitiateCheckout", data);
              } catch (err) {
                Sentry.captureException(err);
                throw err;
              }
            });
        } else {
          // console.log("not found black btn 'buy it now'");
        }
      }, 500);

      // product page paypal
      const listenPaypalBtn = setInterval(() => {
        if (document.querySelector("div[data-testid=PayPalInContext-button]")) {
          console.log("got PaypalBtn");
          clearTimeout(listenPaypalBtn);
          document
            .querySelector("div[data-testid=PayPalInContext-button]")
            .addEventListener("click", () => {
              try {
                const checkoutTitlePrice = getTitlePrice(getProductsData);
                if (checkoutTitlePrice) {
                  data.value = checkoutTitlePrice.price;
                  data.content_name = checkoutTitlePrice.title;
                }
                initPixels(pixelIds);
                emitPixel("InitiateCheckout", data);
              } catch (err) {
                Sentry.captureException(err);
                throw err;
              }
            });
        } else {
          // console.log("not found yellow btn 'buy with paypal'");
        }
      }, 500);

      // product page More Payment Option
      const listenMorePaymentBtn = setInterval(() => {
        if (document.querySelector("button[data-testid=sheet-open-button]")) {
          console.log("got More Payment Option");
          clearTimeout(listenMorePaymentBtn);
          document
            .querySelector("button[data-testid=sheet-open-button]")
            .addEventListener("click", () => {
              try {
                const checkoutTitlePrice = getTitlePrice(getProductsData);
                if (checkoutTitlePrice) {
                  data.value = checkoutTitlePrice.price;
                  data.content_name = checkoutTitlePrice.title;
                }
                initPixels(pixelIds);
                emitPixel("InitiateCheckout", data);
              } catch (err) {
                Sentry.captureException(err);
                throw err;
              }
            });
        } else {
          // console.log("not found page More Payment Option");
        }
      }, 500);

      const cartDrawerDiv = document.getElementById("CartDrawer");
      if (cartDrawerDiv) {
        cartDrawerDiv
          // .getAnimations("body")
          .addEventListener("click", async (e) => {
            // eslint-disable-next-line no-param-reassign
            e = e || window.event; // 兼容ie
            // console.log(e.target.name);
            if (e.target.name == "checkout") {
              e.preventDefault();
              e.stopPropagation();
              try {
                const cartData = await getCart();
                const productIds = Array.from(
                  new Set(cartData.items.map((p) => p.product_id))
                );
                const pixels = await getPixels({
                  myshopifyDomain: Shopify.shop,
                  productIds,
                });
                const drawerCartData = {
                  content_type: "product_group",
                  content_ids: productIds,
                  value: cartData.total_price / 100,
                  num_items: cartData.item_count,
                  currency: cartData.currency,
                };
                initPixels(pixels);
                emitPixel("InitiateCheckout", drawerCartData);
                window.location.href = "/checkout";
              } catch (err) {
                Sentry.captureException(err);
                window.location.href = "/checkout";
                throw err;
              }
            }
          });
      }
    } else if (pathname.match(/^\/cart/)) {
      // cart page
      initPixels(pixelIds);

      const cartData = await getCart();
      const content_ids = [];
      cartData.items.forEach((v) => {
        if (content_ids.indexOf(v.product_id) === -1) {
          content_ids.push(v.product_id);
        }
      });
      const data = {
        content_type: "product_group",
        content_ids,
        value: cartData.total_price / 100,
        num_items: cartData.item_count,
        currency: cartData.currency,
      };
      // get finally cart info when click button, because product's quantity may be changed without refresh page or request
      document
        .querySelector('input[name="checkout"]')
        .addEventListener("click", async (e) => {
          try {
            e.preventDefault();
            e.stopPropagation();
            emitPixel("InitiateCheckout", data);
            window.location.href = "/checkout";
          } catch (err) {
            Sentry.captureException(err);
            window.location.href = "/checkout";
            throw err;
          }
        });

      // paypal for cart page
      window.addEventListener("message", async (event) => {
        if (!event.data.action) {
          if (JSON.parse(event.data).__postRobot__.data) {
            if (JSON.parse(event.data).__postRobot__.data.name === "onClick") {
              try {
                // alert("cart paypal");
                emitPixel("InitiateCheckout", data);
              } catch (err) {
                Sentry.captureException(err);
                throw err;
              }
            }
          }
        }
      });
    } else if (window.location.href.match(/\/search\?q/)) {
      emitPixel("Search", {
        search_string: document.querySelector("input[type=search]").value,
      });
    }
  }
}

(() => {
  if (window.MFP && !window.MFP.isLoadScript) {
    window.MFP.isLoadScript = true;
    document.ready(function() {
      mfpGeneralScript();
    });
  }
})();
